import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {clearSelection} from 'src/components/data-table-selection/services/data-table-selection-slice';

import {FlatButton} from '@pb/kit-component-button';


import {
    applyUpdatedData,
    removeRecords,
} from '../../../services/add-attendees-bulk.slice';
import {SELECTION_KEY} from '../constants';

type Props = {
    selectedRecordIds: number[],
};

export const RemoveRecord = ({selectedRecordIds}: Props) => {
    const dispatch = useDispatch();

    const remove = useCallback(() => {
        dispatch(applyUpdatedData());
        dispatch(removeRecords(selectedRecordIds));
        dispatch(clearSelection(SELECTION_KEY));
    }, [selectedRecordIds, dispatch]);

    return (
        <FlatButton disabled={false} onClick={remove}>
            <strong>
                Remove
            </strong>
        </FlatButton>
    );
};
